export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13335.27bc3d0d.jpg";